import React from 'react';
import PropTypes from 'prop-types';
import Fa from 'react-fontawesome';
import { camelCase } from 'lodash';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';

function LabelRendered(props) {
  const { value, data } = props;
  const isSkipped = data.skip_conversion;
  const lbl = (<strong className="text-uppercase">{value}</strong>);

  if (isSkipped) {
    const tip = (
      <Tooltip
        id={camelCase(`skipped ${data.value}`)}
      >
        <strong>{data.label}</strong> stage is excluded from all calculations.
      </Tooltip>
    );
    return (
      <OverlayTrigger trigger={['hover']} placement="top" overlay={tip}>
        <span className="text-muted">{lbl} <Fa name="exclamation-triangle" /></span>
      </OverlayTrigger>
    );
  }
  return lbl;
}
LabelRendered.propTypes = {
  data: PropTypes.shape({
    skip_conversion: PropTypes.bool,
    label: PropTypes.string,
  }),
  value: PropTypes.string,
};
LabelRendered.defaultProps = {
  value: null,
  data: null,
};
export default LabelRendered;
